import { HttpClient } from "@angular/common/http";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { EventService } from "src/app/core/services/event.service";
import { CreatQrComponentComponent } from "src/app/shared/components/creat-qr-component/creat-qr-component.component";
import { ApiService } from "src/app/shared/services/api.service";
import html2canvas from "html2canvas";

@Component({
  selector: "app-gen-qr-bass",
  templateUrl: "./gen-qr-bass.component.html",
  styleUrls: ["./gen-qr-bass.component.scss"],
})
export class GenQrBassComponent implements OnInit {
  @ViewChild("qrContainer") qrContainer!: ElementRef;

  orderForm!: FormGroup;
  submitted = false;

  constructor(
    private http: HttpClient,
    private apiService: ApiService,
    private modalService: NgbModal,
    private fb: FormBuilder,
    private eventService: EventService,
    private translateService: TranslateService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  // Getter truy cập nhanh nhóm storeInfo trong HTML
  get storeInfo(): FormGroup {
    return this.orderForm.get("storeInfo") as FormGroup;
  }

  // Getters lấy giá trị hiển thị trực tiếp lên QR preview
  get qrAccountValue(): string {
    return this.orderForm.get("storeInfo.qrAccount")?.value || "";
  }

  get accountOwnerValue(): string {
    return this.orderForm.get("storeInfo.accountOwner")?.value || "";
  }
get qrStringValue(): string {
  return (this.orderForm.get("storeInfo.qrString")?.value || "").replace(/\s+/g, "");
}
  private initForm(): void {
    this.orderForm = this.fb.group({
      storeInfo: this.fb.group({
        qrAccount: ["", [Validators.required]],
        accountOwner: [""],
        qrString: ["", [Validators.required]],
      }),
    });
  }

  onCreateQR(data: any) {
    const modalRef = this.modalService.open(CreatQrComponentComponent, {
      centered: true,
      size: "xl",
    });

    modalRef.componentInstance.dataUser = data;
    modalRef.componentInstance.listDevicesQr = data.serial_number;
  }

  // Tra cứu thông tin chủ tài khoản khi blur khỏi ô nhập STK
  onInputBlur() {
    this.eventService.setLoading(true);
    // Reset accountOwner trong nhóm storeInfo
    this.orderForm.get("storeInfo")?.patchValue({ accountOwner: "" });

    // Lấy giá trị qrAccount từ storeInfo
    const qrAccountValue =
      this.orderForm.get("storeInfo.qrAccount")?.value || "";
    if (qrAccountValue === "") {
      this.eventService.setLoading(false);
      return;
    }

    // Chuẩn bị dữ liệu gửi API
    const data = {
      terminalBankAcc: qrAccountValue,
    };

    // Gọi API để tìm thông tin chủ tài khoản
    this.apiService
      .searchBankaccount("affiliate/account-info", data)
      .subscribe({
        next: (response: any) => {
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant("Tìm kiếm thành công")
          );
          // Cập nhật accountOwner trong storeInfo
          this.orderForm.get("storeInfo")?.patchValue({
            accountOwner: response?.metadata?.accountInfo?.accountName,
          });
          this.eventService.setLoading(false);
        },
        error: (e) => {
          if (e) {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(e)
            );
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(
                "Lỗi kết nối. Vui lòng thử lại sau"
              )
            );
          }
          this.eventService.setLoading(false);
        },
      });
  }

  downloadQRCode() {
    const elementToDownload =
      document.querySelector(".qr-with-text").parentElement;

    if (elementToDownload) {
      html2canvas(elementToDownload as HTMLElement).then((canvas) => {
        const qrUrl = canvas.toDataURL("image/png");

        const link = document.createElement("a");
        link.href = qrUrl;
        link.download = `QR_Code_${this.orderForm.get("storeInfo.qrAccount")?.value}.png`;
        link.click();
      });
    } else {
      console.error("Không tìm thấy phần tử.");
    }
  }
  printQRCode() {
    // Lấy phần tử cần in
    const elementToPrint =
      document.querySelector(".qr-with-text")?.parentElement;

    if (!elementToPrint) {
      console.error("Không tìm thấy phần tử để in.");
      return;
    }

    html2canvas(elementToPrint).then((canvas) => {
      const qrUrl = canvas.toDataURL("image/png");

      const printWindow = window.open("", "_blank");
      printWindow?.document.write(`
        <html>
          <head>
            <title>In QR Code</title>
            <style>
              @media print {
                body {
                  margin: 0;
                  padding: 0;
                }
                .print-container {
                  text-align: center;
                  width: 100%;
                  max-width: 450px; 
                  // padding-top: 10px;
                }
                img {
                  // width: 55mm;
                  // height: 55mm;
                  // object-fit: contain;
                  width: 100%; 
                  height: auto;

                }
                @page {
                  margin: 0;
                }
              }
            </style>
          </head>
          <body>
            <div class="print-container">
              <img src="${qrUrl}" />
            </div>
          </body>
        </html>
      `);

      printWindow?.document.close();
      printWindow?.addEventListener("load", () => {
        printWindow?.print();
        printWindow?.close();
      });
    });
  }
}